var _rect, _rect2, _rect3, _circle, _circle2, _path, _path2, _rect4, _rect5, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 30,
    viewBox: "0 0 189 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 59,
    width: 26,
    height: 6,
    rx: 3,
    fill: "url(#paint0_linear_0_1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 70,
    width: 26,
    height: 6,
    rx: 3,
    fill: "url(#paint1_linear_0_1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 81,
    width: 26,
    height: 6,
    rx: 3,
    fill: "url(#paint2_linear_0_1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 73,
    r: 6,
    fill: "url(#paint3_linear_0_1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 155,
    r: 6,
    fill: "url(#paint4_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44063 139.691C-2.39364 98.9187 6.18651 62.5761 11.5 50.5C13.7095 45.4785 14.4692 43.6317 14.6836 43.046C14.3844 43.5165 14.9477 42.3246 14.6836 43.046C14.7462 42.9476 14.8465 42.7765 15 42.5C18.3382 36.4856 20.4776 34.183 25 29C29.361 24.0019 32.2289 21.5267 37.5 17.5C44.1794 12.3974 48.2303 9.70641 56 6.50001C64.8884 2.83195 70.4452 2.07918 80 1.00001C94.2668 -0.61137 116.303 3.11839 118.347 3.47318C118.46 3.49277 118.553 3.51326 118.664 3.54196C119.502 3.75901 123.602 4.8481 132 7.49997C139.932 10.0049 143.452 11.7891 150.441 16.9563C150.48 16.985 150.514 17.0112 150.552 17.0412C151.486 17.7805 164.713 28.3379 170.5 37.5C174.396 42.4968 176.47 46.7746 179.5 51L182.002 55.6186C183.806 58.9501 181.394 63 177.605 63H147.987C145.225 63 142.987 60.7614 142.987 58V53C142.987 50.2386 140.748 48 137.987 48H118.5H96H51.5C48.7386 48 46.5 50.2386 46.5 53V94.5C46.5 97.2614 48.7386 99.5 51.5 99.5H96H137.987C140.748 99.5 142.987 97.2614 142.987 94.5V89.2103C142.987 86.3681 145.377 84.1005 148.217 84.1965C190.603 85.6282 186.111 81.4356 186.002 89.7063C185.999 89.8958 186.01 90.0859 186.031 90.2742C186.255 92.2714 187.631 104.735 188 113C188.42 122.393 188.015 136.984 188 137.487L188 137.516C187.99 138.016 187.724 150.312 186 158L185.885 158.512C184.278 165.687 183.252 170.263 180 177C173.408 190.655 160.164 201.207 158.643 202.389C158.545 202.466 158.448 202.534 158.343 202.601L150 208L141.811 213.299C141.604 213.433 141.387 213.551 141.163 213.653L130.826 218.352C130.609 218.451 130.385 218.533 130.157 218.6L118.601 221.971C118.534 221.99 118.473 222.007 118.405 222.023C117.276 222.298 106.302 224.94 98.9865 225.5C93.151 225.947 85 225.5 84 225.5C83 225.5 72.1656 224.362 65 222C59.9348 220.331 57.2556 218.914 52.5 216.5C46.4084 213.408 43.1354 211.361 37.5 207.5C34.8197 205.664 30.9332 202.712 30.1432 202.109C30.046 202.035 29.9542 201.959 29.8628 201.878L25.5 198L21.1198 193.62C21.04 193.54 20.9646 193.459 20.8904 193.374C20.2612 192.652 17.0637 188.978 15 186.5C12.4284 183.412 9.45616 178.21 8.6885 176.839C8.56094 176.611 8.41983 176.396 8.26024 176.19L6.22605 173.557C3.68644 170.271 6.02903 165.5 10.1825 165.5H41.5C44.2614 165.5 46.5 167.739 46.5 170.5V176C46.5 178.761 48.7386 181 51.5 181H96H137.987C140.748 181 142.987 178.761 142.987 176V133.5C142.987 130.739 140.748 128.5 137.987 128.5H102.5H51.5C48.7386 128.5 46.5 130.739 46.5 133.5V139C46.5 141.761 44.2614 144 41.5 144H25H7.3437C4.85232 144 2.73397 142.165 2.44063 139.691Z",
    fill: "url(#paint5_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 50.5C6.18651 62.5761 -2.39364 98.9187 2.44063 139.691C2.73397 142.165 4.85232 144 7.3437 144H25H41.5C44.2614 144 46.5 141.761 46.5 139V133.5C46.5 130.739 48.7386 128.5 51.5 128.5H102.5H137.987C140.748 128.5 142.987 130.739 142.987 133.5V176C142.987 178.761 140.748 181 137.987 181H96H51.5C48.7386 181 46.5 178.761 46.5 176V170.5C46.5 167.739 44.2614 165.5 41.5 165.5H10.1825C6.02903 165.5 3.68644 170.271 6.22605 173.557L8.26024 176.19C8.41983 176.396 8.56094 176.611 8.6885 176.839C9.45616 178.21 12.4284 183.412 15 186.5C17.0637 188.978 20.2612 192.652 20.8904 193.374C20.9646 193.459 21.04 193.54 21.1198 193.62L25.5 198L29.8628 201.878C29.9542 201.959 30.046 202.035 30.1432 202.109C30.9332 202.712 34.8197 205.664 37.5 207.5C43.1354 211.361 46.4084 213.408 52.5 216.5C57.2556 218.914 59.9348 220.331 65 222C72.1656 224.362 83 225.5 84 225.5C85 225.5 93.151 225.947 98.9865 225.5C106.302 224.94 117.276 222.298 118.405 222.023C118.473 222.007 118.534 221.99 118.601 221.971L130.157 218.6C130.385 218.533 130.609 218.451 130.826 218.352L141.163 213.653C141.387 213.551 141.604 213.433 141.811 213.299L150 208L158.343 202.601C158.448 202.534 158.545 202.466 158.643 202.389C160.164 201.207 173.408 190.655 180 177C183.329 170.104 184.325 165.472 186 158C187.724 150.312 187.99 138.016 188 137.516C188 137.5 188 137.503 188 137.487C188.015 136.984 188.42 122.393 188 113C187.631 104.735 186.255 92.2714 186.031 90.2742C186.01 90.0859 185.999 89.8958 186.002 89.7063C186.111 81.4356 190.603 85.6281 148.217 84.1965C145.377 84.1005 142.987 86.3681 142.987 89.2103V94.5C142.987 97.2614 140.748 99.5 137.987 99.5H96H51.5C48.7386 99.5 46.5 97.2614 46.5 94.5V53C46.5 50.2386 48.7386 48 51.5 48H96H118.5H137.987C140.748 48 142.987 50.2386 142.987 53V58C142.987 60.7614 145.225 63 147.987 63H177.605C181.394 63 183.806 58.9501 182.002 55.6186L179.5 51C176.47 46.7745 174.396 42.4968 170.5 37.5C164.713 28.3379 151.486 17.7805 150.552 17.0412C150.514 17.0112 150.48 16.985 150.441 16.9563C143.452 11.7891 139.932 10.0049 132 7.49997C123.602 4.8481 119.502 3.75901 118.664 3.54196C118.553 3.51326 118.46 3.49277 118.347 3.47318C116.303 3.11839 94.2668 -0.61137 80 1.00001C70.4452 2.07918 64.8884 2.83195 56 6.50001C48.2303 9.70641 44.1794 12.3974 37.5 17.5C32.2289 21.5267 29.361 24.0019 25 29C20.4776 34.183 18.3382 36.4856 15 42.5C13.5168 45.1723 17 38 11.5 50.5Z",
    stroke: "url(#paint6_linear_0_1)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 141,
    width: 26,
    height: 6,
    rx: 3,
    fill: "url(#paint7_linear_0_1)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 152,
    width: 26,
    height: 6,
    rx: 3,
    fill: "url(#paint8_linear_0_1)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 163,
    width: 26,
    height: 6,
    rx: 3,
    fill: "url(#paint9_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 110,
    y1: 62,
    x2: 136,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 110,
    y1: 73,
    x2: 136,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 110,
    y1: 84,
    x2: 136,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 60,
    y1: 67,
    x2: 60,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81CF60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 133,
    y1: 149,
    x2: 133,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 98.9999,
    y1: 7,
    x2: 98.9999,
    y2: 227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#57FA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12700B",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 94.0949,
    y1: 2.74864,
    x2: 94.0949,
    y2: 225.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81F151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_1",
    x1: 54,
    y1: 144,
    x2: 80,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_1",
    x1: 54,
    y1: 155,
    x2: 80,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_1",
    x1: 54,
    y1: 166,
    x2: 80,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon-logo.6ed0dd3518336fbe9ddaf9d4b3b71839.svg";
export { ForwardRef as ReactComponent };